'use client';

import MasterLayout from '@/app/components/layout/master-layout';
import DeviceManageLayout from '@/app/components/layouts/device-manage';

import ContactUs from './contact-us';
// import ResellerPromo from './reseller-promo';

export default function BecomeResellerView() {
  return (
    <MasterLayout>
      <DeviceManageLayout
        title="Do you want to be a reseller?"
        description="This page is dedicated for resellers. For troubleshooting or any issue please contact us."
      >
        {/* <ResellerPromo /> */}

        <ContactUs />
      </DeviceManageLayout>
    </MasterLayout>
  );
}
